"use strict";

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var domElements_1 = __importDefault(require("./domElements"));

var tailwindcss_classnames_1 = require("tailwindcss-classnames");

var cleanTemplate = function cleanTemplate(template) {
  var inheritedClasses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var newClasses = template.toString().trim().replace(/\s{2,}/g, " ").split(" ").filter(function (c) {
    return c !== ",";
  });
  var inheritedClassesArray = inheritedClasses ? inheritedClasses.split(" ") : [];
  return tailwindcss_classnames_1.classnames.apply(tailwindcss_classnames_1, _toConsumableArray(inheritedClassesArray.concat(newClasses).filter(function (c) {
    return c !== " ";
  }).filter(function (v, i, arr) {
    return arr.indexOf(v) === i;
  }))).split(" ");
};

function parseTailwindClassNames(template) {
  for (var _len = arguments.length, templateElements = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    templateElements[_key - 1] = arguments[_key];
  }

  return template.reduce(function (sum, n, index) {
    var templateElement = templateElements[index];

    if (typeof templateElement === "string") {
      return "".concat(sum, " ").concat(n, " ").concat(templateElement);
    }

    return "".concat(sum, " ").concat(n);
  }, "").trim().replace(/\s{2,}/g, " ");
}

var functionTemplate = function functionTemplate(Element) {
  return function (template) {
    for (var _len2 = arguments.length, templateElements = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      templateElements[_key2 - 1] = arguments[_key2];
    }

    return react_1.default.forwardRef(function (_ref, ref) {
      var children = _ref.children,
          props = _objectWithoutProperties(_ref, _excluded);

      return react_1.default.createElement(Element, Object.assign({}, props, {
        ref: ref,
        className: parseTailwindClassNames.apply(void 0, [cleanTemplate(template, props.className)].concat(_toConsumableArray(templateElements.map(function (t) {
          return t(props);
        }))))
      }), children);
    });
  };
};

var intrinsicElements = domElements_1.default.reduce(function (acc, domElement) {
  return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, domElement, functionTemplate(domElement)));
}, {});
var tw = Object.assign(function (Component) {
  return functionTemplate(Component);
}, intrinsicElements);
exports.default = tw;